module.exports = __webpack_public_path__ + "media/images/shoretime_white_transparent-b3b9e2df4689aca4c3917eaab22c7cb7.png";